export default __webpack_public_path__ + "b55fb010f563212f4df43231ab3e10a3.png";